import { Action } from 'redux';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetCertification } from '../AppActionTypes';

export interface SetCertificationAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'>;
}

export function setCertificationAction(item: IContentInfo<'database'> | IContentInfo<'table'>): SetCertificationAction {
  return {
    type: SetCertification,
    item
  };
}
